/**
 * Parse time string like "10:15 AM", "9:5 AM", or "10:30" into { hours, minutes } in 24h.
 * Handles both single and double-digit hours and minutes.
 * Returns null if the string does not match a supported format.
 */
export function parseStartTime(
  startTime: string
): { hours: number; minutes: number } | null {
  const match12 = startTime.trim().match(/^(\d{1,2}):(\d{1,2})\s*(AM|PM)$/i);
  if (match12) {
    let hours = parseInt(match12[1], 10);
    const minutes = parseInt(match12[2], 10);
    if (match12[3].toUpperCase() === "PM" && hours !== 12) hours += 12;
    if (match12[3].toUpperCase() === "AM" && hours === 12) hours = 0;
    return { hours, minutes };
  }
  const match24 = startTime.trim().match(/^(\d{1,2}):(\d{1,2})$/);
  if (match24) {
    return {
      hours: parseInt(match24[1], 10),
      minutes: parseInt(match24[2], 10),
    };
  }
  return null;
}
